import { useState } from "react";
import {
  getActiveOrdersMonitor,
  getQueueOrdersMonitor,
  getTodayOrdersMonitor,
} from "../../../api/Monitor";

const useActiveOrdersMonitor = () => {
  const [activeOrders, setActiveOrders] = useState({});
  const [todayOrders, setTodayOrders] = useState({});
  const [queuedOrders, setQueuedOrders] = useState({});

  const getActiveOrders = async (body) => {
    try {
      const response = await getActiveOrdersMonitor(body);
      if (!response.error && response.status === 200) {
        setActiveOrders(response.data || {});
      }
    } catch (e) {
      console.error(e);
    }
  };

  const getTodayOrders = async (body) => {
    try {
      const response = await getTodayOrdersMonitor(body);
      if (!response.error && response.status === 200) {
        setTodayOrders(response.data || {});
      }
    } catch (e) {
      console.error(e);
    }
  };

  const getQueuedOrders = async (body) => {
    try {
      const response = await getQueueOrdersMonitor(body);
      if (!response.error && response.status === 200) {
        setQueuedOrders(response.data || {});
      }
    } catch (e) {
      console.error(e);
    }
  };

  return {
    activeOrders,
    todayOrders,
    queuedOrders,
    getActiveOrders,
    getTodayOrders,
    getQueuedOrders,
  };
};

export default useActiveOrdersMonitor;
